import { jsx as _jsx } from "react/jsx-runtime";
import { Canvas, Sprite } from './styles';
export var LoadingSpinner = function (_a) {
  var size = _a.size;
  return _jsx(Canvas, {
    size: size,
    children: _jsx(Sprite, {
      src: window._ASSETS.SpinnerImg
    })
  });
};